import { render, staticRenderFns } from "./AmeldingListWorkRelation.vue?vue&type=template&id=116063d9&scoped=true&"
import script from "./AmeldingListWorkRelation.vue?vue&type=script&lang=ts&"
export * from "./AmeldingListWorkRelation.vue?vue&type=script&lang=ts&"
import style0 from "./AmeldingListWorkRelation.vue?vue&type=style&index=0&id=116063d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116063d9",
  null
  
)

export default component.exports